module.exports = __webpack_public_path__ + "static/media/CTLI_9-293w.66863680.jpg";